export default __webpack_public_path__ + "static/media/total-sales.10b46d96.svg";